import { resetPasswordState } from '../state/resetPasswordState'
import { RESET_USER_PASSWORD_REQUEST, RESET_USER_PASSWORD_SUCCESS,
            RESET_USER_PASSWORD_ERROR,RESET_USER_PASSWORD_REQUEST12, RESET_USER_PASSWORD_SUCCESS12,
    RESET_USER_PASSWORD_ERROR12, FETCH_USER_PASSWORD_REQUEST12,
         } from '../actions/resetPasswordAction'

import {
    ADD_COMPANY_REQUEST, APPLICATION_REQUEST,
} from '../actions/forgotPasswordAction'
export function resetPasswordReducer(state = resetPasswordState, action) {
    switch (action.type) {
          case RESET_USER_PASSWORD_ERROR12:
        
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
        
                        otpstatusCode: action.statusCode,
                        errorCode: action.errorCode,
                        errorMessage: action.errorMessage,
        
        
                    })
                    case RESET_USER_PASSWORD_REQUEST12:
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
                        
                        errorMessage: '',
                       otpstatusCode: '',
                    })
                case FETCH_USER_PASSWORD_REQUEST12:
                    return Object.assign({}, state, {
                        isLoading: false,
                        errorMessage: '',
                        otpstatusCode: '',
                    })
                case RESET_USER_PASSWORD_SUCCESS12:
                    debugger
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
                        errorMessage: action.errorMessage,
                        otpstatusCode: action.statusCode,
                    })
                case RESET_USER_PASSWORD_ERROR12:
        
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
        
                        otpstatusCode: action.statusCode,
                        errorCode: action.errorCode,
                        errorMessage: action.errorMessage,
        
        
                    })
        
                     case RESET_USER_PASSWORD_ERROR12:
        
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
        
                        otpstatusCode: action.statusCode,
                        errorCode: action.errorCode,
                        errorMessage: action.errorMessage,
        
        
                    })

          case ADD_COMPANY_REQUEST:

            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: false,
                Message: 'Success',
                brandList: action.brandList
            })
        case APPLICATION_REQUEST:
            return Object.assign({}, state, {
                errorCode: 0,
                statusCode: 0,
                isLoading: action.isLoading,
                Message: ''
            })
        case RESET_USER_PASSWORD_REQUEST:
            
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                errorMessage: '',
                statusCode: '',
            })
        case RESET_USER_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                errorMessage: action.errorMessage,
                statusCode: action.statusCode,
            })
        case RESET_USER_PASSWORD_ERROR:
            
            return Object.assign({}, state, {
                statusCode: action.statusCode,
                errorCode: action.errorCode,
                errorMessage: action.errorMessage,
            })
       
        default:
            return state;
    }
} 
